module.exports = __webpack_public_path__ + "img/map_Z1.5.B.02.4fa39507.svg";